@if (
  {
    billingEquipements: billingEquipements$() | async,
    isSubmitting: isSubmitting(),
    displayBlock: equipmentDeclaration(),
    designation: designations$() | async
  };
  as STATE
) {
  <div class="billing__equipment">
    <section class="billing__equipment__header">
      <hgroup>
        <h2>Déclaration des équipements de facturation</h2>
        <p>
          Indiquez les équipements de facturation dont vous disposez afin de les
          enregistrer
        </p>
      </hgroup>

      <article class="billing__equipment__header--description">
        Pour assurer une meilleure prise en charge, veuillez indiquer les
        équipements de facturation (logiciels, caisses, terminaux de paiement)
        que vous utilisez dans votre entreprise.
      </article>
    </section>

    <form
      [formGroup]="billingEquipmentDeclarationform"
      [ngxsForm]="statePropertyPath"
      (ngSubmit)="onSubmit()"
      class="form"
    >
      <section class="billing__equipment__section">
        <article class="billing__equipment__section--split">
          <hgroup>
            <h3>
              Votre entreprise utilise-t-elle des équipements de facturation
              pour émettre ses factures ?
            </h3>
            <p class="billing__equipment__section--description">
              Indiquez les équipements de facturation que vous utilisez
              (Logiciels de facturation, Carnet pré-imprimé, Autres) afin de les
              déclarer sur la plateforme.
            </p>
          </hgroup>
          <p>
            <mat-slide-toggle
              id="usesBillingEquipment"
              [checked]="STATE.displayBlock['usesBillingEquipment']"
              (change)="handleSlideChangeValue($event)"
            ></mat-slide-toggle>
          </p>
        </article>

        @if (STATE.displayBlock['usesBillingEquipment']) {
          <div formArrayName="equipments">
            @for (
              equits of equipements.controls;
              track $index;
              let i = $index;
              let last = $last
            ) {
              <article
                class="billing__equipment__section__form"
                [formGroupName]="i"
              >
                <div
                  class="billing__equipment__section__group billing__equipment__section__group--field"
                >
                  <section class="form__group">
                    <label for="type-{{ i }}" class="form__label"
                      >Type(s) d’équipement
                      <span class="form__label--required">*</span>
                    </label>
                    <div class="form__item form__item--with-prefix">
                      <span class="form__prefix">
                        <mat-icon
                          svgIcon="dgi-list-otp"
                          color="primary"
                        ></mat-icon>
                      </span>
                      <ng-select
                        [items]="$any(STATE.billingEquipements)"
                        id="type-{{ i }}"
                        [closeOnSelect]="true"
                        [clearable]="true"
                        [searchable]="true"
                        formControlName="type"
                        bindLabel="label"
                        bindValue="value"
                        clearAllText="Effacer"
                        placeholder="Sélectionner le type d’équipement"
                      >
                        <ng-template ng-option-tmp let-item="item">
                          {{ item?.label }}
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item">
                          {{ item?.label }}
                        </ng-template>
                      </ng-select>
                    </div>
                    @if (isFieldInvalid(i, 'type')) {
                      <mat-error
                        [innerHtml]="'Ce champ est requis'"
                        class="form__error-red"
                      >
                      </mat-error>
                    }
                  </section>

                  @if (
                    equipements.at(i).get('type')?.value ===
                    'Logiciel de facturation'
                  ) {
                    <section class="form__group">
                      <label for="name-{{ i }}" class="form__label"
                        >Désignation
                        <span class="form__label--required">*</span>
                      </label>
                      <div class="form__item form__item--with-prefix">
                        <span class="form__prefix">
                          <mat-icon
                            svgIcon="dgi-list-otp"
                            color="primary"
                          ></mat-icon>
                        </span>
                        <ng-select
                          [items]="STATE.designation ?? []"
                          id="name-{{ i }}"
                          [closeOnSelect]="true"
                          [clearable]="true"
                          [searchable]="true"
                          formControlName="name"
                          bindLabel="label"
                          bindValue="value"
                          clearAllText="Effacer"
                          placeholder="Saisir ou sélectionner une suggestion"
                          required
                        >
                        </ng-select>
                      </div>
                      @if (isFieldInvalid(i, 'name')) {
                        <mat-error
                          [innerHtml]="'Ce champ est requis'"
                          class="form__error-red"
                        >
                        </mat-error>
                      }
                    </section>
                  }

                  @if (
                    showOtherDesignation[i] ||
                    equipements.at(i).get('type')?.value === 'Autres'
                  ) {
                    <section class="form__group">
                      <label for="otherValue-{{ i }}" class="form__label"
                        >Désignation (Autres)
                        <span class="form__label--required">*</span>
                      </label>
                      <div class="form__item form__item--with-prefix">
                        <span class="form__prefix">
                          <mat-icon
                            svgIcon="dgi-list-otp"
                            color="primary"
                          ></mat-icon>
                        </span>
                        <input
                          type="text"
                          id="otherValue-{{ i }}"
                          formControlName="otherValue"
                          class="form__input"
                          placeholder="Veuillez saisir la designation ici..."
                        />
                      </div>
                      @if (isFieldInvalid(i, 'name')) {
                        <mat-error
                          [innerHtml]="'Ce champ est requis'"
                          class="form__error-red"
                        >
                        </mat-error>
                      }
                    </section>
                  }
                </div>

                <div class="billing__equipment__section__actions">
                  @if (i > 0) {
                    <button
                      button
                      [disabled]="i === 0"
                      type="button"
                      class="billing__equipment__section__actions--btn-remove"
                      (click)="removeEquipement(i)"
                      [variant]="'destructive'"
                      size="default"
                    >
                      <ng-container
                        *ngTemplateOutlet="trashIcon"
                      ></ng-container>
                      <span
                        class="billing__equipment__section__actions--btn-remove__text"
                      >
                        Retirer la ligne
                      </span>
                    </button>
                  }

                  @if (last) {
                    <button
                      class="billing__equipment__section__actions--btn-add"
                      button
                      type="button"
                      size="default"
                      [variant]="'outline'"
                      (click)="addEquipement()"
                    >
                      <ng-container *ngTemplateOutlet="plusIcon"></ng-container>
                      <span
                        class="billing__equipment__section__actions--btn-add__text"
                      >
                        Ajouter un nouvel équipement
                      </span>
                    </button>
                  }
                </div>
              </article>
            }
          </div>
        }
      </section>

      <section class="billing__equipment__section">
        <article class="billing__equipment__section--split">
          <hgroup>
            <h3>
              Votre entreprise utilise-t-elle une ou plusieurs caisses
              enregistreuses ?
            </h3>
            <p class="billing__equipment__section--description">
              Indiquez le nombre de caisse enregistreuse dont dispose votre
              entreprise.
            </p>
          </hgroup>
          <p>
            <mat-slide-toggle
              id="usesCashRegisters"
              [checked]="STATE.displayBlock['usesCashRegisters']"
              (change)="handleSlideChangeValue($event)"
            ></mat-slide-toggle>
          </p>
        </article>

        @if (STATE.displayBlock['usesCashRegisters']) {
          <article class="billing__equipment__section__group">
            <section class="form__group">
              <label for="cashRegistersNumber" class="form__label"
                >Nombre de caisses enregistreuses
                <span class="form__label--required">*</span>
              </label>
              <div class="form__item form__item--with-prefix">
                <span class="form__prefix">
                  <mat-icon svgIcon="dgi-list-otp" color="primary"></mat-icon>
                </span>
                <input
                  type="number"
                  formControlName="cashRegistersNumber"
                  id="cashRegistersNumber"
                  required
                  min="0"
                  class="form__input"
                  placeholder="Ex. 10"
                />
              </div>
              @if (
                getFieldControl('cashRegisterNumber')?.touched &&
                getFieldControl('cashRegisterNumber')?.errors?.required
              ) {
                <mat-error
                  [innerHtml]="'Ce champ est requis'"
                  class="form__error-red"
                >
                </mat-error>
              }
            </section>
          </article>
        }
      </section>

      <mat-divider class="form__divider"></mat-divider>

      <section class="form__actions billing__equipment__actions">
        <button
          type="button"
          (click)="handlePrevStep()"
          class="btn btn-outline-primary billing__equipment__actions--btn-prev"
        >
          <mat-icon svgIcon="dgi-arrow-left"></mat-icon>
          <span class="billing__equipment__actions--label"> Précédent </span>
        </button>

        <button
          type="submit"
          [disabled]="
            STATE.isSubmitting || billingEquipmentDeclarationform.invalid
          "
          [attr.loading]="STATE.isSubmitting"
          class="btn btn-primary billing__equipment__actions--btn-submit"
        >
          Suivant
        </button>
      </section>
    </form>
  </div>
}

<ng-template #trashIcon>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    color="currentColor"
    fill="none"
  >
    <path
      d="M4.47461 6.10018L5.31543 18.1768C5.40886 19.3365 6.28178 21.5536 8.51889 21.8022C10.756 22.0507 15.2503 21.9951 16.0699 21.9951C16.8895 21.9951 19.0128 21.4136 19.0128 19.0059C19.0128 16.5756 16.9833 15.9419 15.7077 15.9635H12.0554M12.0554 15.9635C12.0607 15.7494 12.1515 15.5372 12.3278 15.3828L14.487 13.4924M12.0554 15.9635C12.0497 16.1919 12.1412 16.4224 12.33 16.5864L14.487 18.4609M19.4701 5.82422L19.0023 13.4792"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3 5.49561H21M16.0555 5.49561L15.3729 4.08911C14.9194 3.15481 14.6926 2.68766 14.3015 2.39631C14.2148 2.33168 14.1229 2.2742 14.0268 2.22442C13.5937 2 13.0739 2 12.0343 2C10.9686 2 10.4358 2 9.99549 2.23383C9.89791 2.28565 9.80479 2.34547 9.7171 2.41265C9.32145 2.7158 9.10044 3.20004 8.65842 4.16854L8.05273 5.49561"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg> </ng-template
><ng-template #plusIcon>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    color="currentColor"
    fill="none"
  >
    <path
      d="M12.001 5.00003V19.002"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M19.002 12.002L4.99998 12.002"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </svg>
</ng-template>
